import React from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { trackApplyButton } from '@/utils/dataLayer'
import { RxArrowTopRight } from "react-icons/rx"
import CapIcon from "@/images/cap-icon.svg"
import GlobalIcon from "@/images/global-icon.svg"
import BagIcon from "@/images/bag-icon.svg"
import IdeaIcon from "@/images/idea-icon.svg"
import { useTranslation } from "next-i18next";

const OurMission = () => {
    const { t } = useTranslation();

    const missionCards = [
        {
            icon: CapIcon,
            text: t("about-us-page.our-mission-card-1")
        },
        {
            icon: GlobalIcon,
            text: t("about-us-page.our-mission-card-2")
        },
        {
            icon: BagIcon,
            text: t("about-us-page.our-mission-card-3")
        },
        {
            icon: IdeaIcon,
            text: t("about-us-page.our-mission-card-4")
        }
    ]

    return (
        <div className="bg-white max-w-[90%] md:py-[200px] py-[40px] mx-auto">
            <div className="flex flex-col lg:flex-row items-center justify-between gap-6 lg:gap-12 mb-[32px] md:mb-[64px]">
                <div className="flex flex-col items-start md:items-center w-full md:w-auto">
                    <h2 className="text-[32px] md:text-[48px] lg:text-[64px] font-[500] leading-tight flex flex-col md:flex-row gap-0 md:gap-4">
                        <span className="text-transparent bg-clip-text bg-gradient-to-b from-[#091F59] to-[#1A3884]">{t("about-us-page.our-mission-title-1")}</span>
                        <span className="text-main-pink">{t("about-us-page.our-mission-title-2")}</span>
                    </h2>
                </div>
                <div className="flex flex-col gap-4 lg:max-w-md w-full md:w-auto">
                    <Link href="/apply" onClick={() => trackApplyButton("our_mission")}>
                        <button className="w-full md:w-[200px] h-[48px] md:h-[56px] flex items-center justify-center gap-2 px-6  border border-[#274DE0] rounded-full text-[#274DE0] text-[14px] sm:text-[16px] font-[500] transition-all duration-300 cursor-pointer hover:!bg-[#274DE0] hover:!text-white">
                            {t("join-us")}
                            <RxArrowTopRight className="w-[20px] h-[20px] md:w-[24px] md:h-[24px]" />
                        </button>
                    </Link>
                </div>
            </div>

            <div className="flex flex-row flex-wrap justify-center items-center gap-[60px] md:gap-[75px]">
                {missionCards.map((card, index) => (
                    <div
                        key={index}
                        className={`bg-white ${index < 2 ? 'max-w-full md:max-w-[320px] lg:max-w-[370px] xl:max-w-[500px] 2xl:max-w-[600px]' : 'max-w-full md:max-w-[320px] xl:max-w-[400px] 2xl:max-w-[500px]'} w-full rounded-[32px] p-6 md:p-8 flex flex-col items-center justify-center gap-4 md:gap-6 shadow-[0px_0px_18px_8px_rgba(0,0,0,0.05)]`}
                    >
                        <div className="w-[60px] h-[60px] lg:w-[100px] lg:h-[100px] flex items-center justify-center shadow-[0px_0px_10px_8px_rgba(0,0,0,0.05)] md:shadow-[0px_0px_18px_8px_rgba(0,0,0,0.05)] rounded-full">
                            <Image
                                src={card.icon}
                                alt="mission icon"
                                width={66}
                                height={66}
                                className="object-contain w-[40px] h-[40px] lg:w-[60px] lg:h-[60px]"
                                loading="lazy"
                            />
                        </div>
                        <p className="text-[16px] xl:text-[24px] text-black text-center leading-relaxed font-[500]">
                            {card.text}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default OurMission
